export default __webpack_public_path__ + "static/media/44_double_g.9f4fe7e1.png";